import React, { Component } from "react";
import SchoolFilterGroup from "./components/SchoolFilterGroup";
import "./style.css";
import "../../../../../index.css";
class ToCollageSchoolFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limits: [],
      schoolLevelIds: [],
      schoolTagIds: [],
      schoolPropertyIds: [],
      provinceIds: [],
      pageNum: 1,
      pageSize: 20,
    };
  }
  render() {
    const { visible, handleVisibleFilter, filterData } = this.props;
    return (
      <div
        className={
          visible === true
            ? "school_filter_box"
            : "school_filter_box display_none"
        }
      >
        <div className="school_filter_inline_box fr">
          {filterData != null ? (
            <div>
              {filterData.map((item, index) => {
                return (
                  <SchoolFilterGroup
                    onRef={this.onRef.bind(this)}
                    key={index}
                    name={item.name}
                    filters={item.filters}
                  ></SchoolFilterGroup>
                );
              })}
              <div style={{ height: 60 }}></div>
              <div className="school_filter_inline_box_bottom">
                <div className="school_filter_inline_box_bottom_inline">
                  <div
                    onClick={() => this.handleReset()}
                    className="major_filter_inline_box_bottom_btn_fl fl"
                  >
                    重置
                  </div>
                  <div
                    onClick={() => this.handleConfirm()}
                    className="major_filter_inline_box_bottom_btn_fr fr"
                  >
                    确定
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          onClick={handleVisibleFilter}
          className="school_filter_inline_click fl"
        ></div>
      </div>
    );
  }
  /**
   * 重置高校过滤组件的数据
   */
  handleReset = () => {
    this.schoolFilterGroup.resetUIState();
      this.setState({
        schoolLevelIds: [],
        schoolTagIds: [],
        schoolPropertyIds: [],
        provinceIds: [],
        limits: [],
        pageNum: 1,
        pageSize: 20,
      });
  };
  /**
   * 高校过滤组件确定事件
   */
  handleConfirm = () => {
      this.props.handleVisibleFilter();
      this.props.requestUserData();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
  };
  // 获取子组件
  onRef = (name, ref) => {
    switch (name) {
      case "schoolFilterGroup":
        this.schoolFilterGroup = ref;
        break;
      default:
        break;
    }
  };
}
export default ToCollageSchoolFilter;



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollageToolFilter/components/ToCollageSchoolFilter/index.js